import { z } from "zod";

export const airportSearchSchema = z.object({
  departure_airport: z.object({
    id: z.string().optional(),
    city: z.string().optional(),
    code: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    name: z.string().optional(),
    region: z.string().optional()
  }).nullable(),
  arrival_airport: z.object({
    id: z.string().optional(),
    city: z.string().optional(),
    code: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    name: z.string().optional(),
    region: z.string().optional()
  }).nullable()
});

export type AirportSearchData = z.infer<typeof airportSearchSchema>;
